import * as ko from "knockout";
import fetch from 'node-fetch';
import template from './PageFooter.html';
import { gitVersion } from '../git-version';
import { Link, LinkSet } from '../contracts';

class PageFooter {

  disclaimer: ko.Observable<string> = ko.observable<string>("");
  backendVersion: ko.Observable<string> = ko.observable<string>("");
  frontendVersion: ko.Observable<string> = ko.observable<string>(global.Logonme.Configuration.version);
  footerLinks: ko.ObservableArray<Link> = ko.observableArray<Link>([]);
  footerColumns: ko.ObservableArray<LinkSet> = ko.observableArray<LinkSet>([]);

  // Computed properties - initialized in constructor
  selectedLanguage: ko.PureComputed<string>;

  constructor() {
    // Initialize computed properties
    this.selectedLanguage = ko.pureComputed<string>(() => global.Logonme.SelectedLanguage());

    this.updateBackendVersion();
    this.updateFrontendVersion();

    this.updateStrings(this.selectedLanguage());
    this.selectedLanguage.subscribe((lang: string) => {
      this.updateStrings(lang);
    });
  }

  private updateStrings(lang: string): void {
    this.disclaimer(global.Logonme.LocalizationManager.getText('footer-disclaimer', lang));

    this.footerLinks([]);
    const linkColumns = 10;
    for (let i = 1; i <= linkColumns; i++) {
      const linkText = global.Logonme.LocalizationManager.getText(`footer-link${i}-text`, lang);
      const linkUri = global.Logonme.LocalizationManager.getText(`footer-link${i}-src`, lang);
      if (linkText !== null && linkText !== "" && linkUri !== null && linkUri !== "") {
        this.footerLinks.push(new Link(linkUri, linkText, null));
      }
    }

    this.footerColumns([]);
    const columnCount = 10;
    for (let i = 1; i <= columnCount; i++) {
      const headerText = global.Logonme.LocalizationManager.getText(`footer-column${i}-header`, lang);
      const headerUri = global.Logonme.LocalizationManager.getText(`footer-column${i}-src`, lang);
      const headerImageSrc = global.Logonme.LocalizationManager.getText(`footer-column${i}-image-src`, lang);

      const imageSrc = headerImageSrc ? `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/asset/${headerImageSrc}` : null;
      const header = (headerText !== null && headerText !== "") ? new Link(headerUri, headerText, imageSrc) : null;

      if (header !== null) {
        const rows = 5;
        const links = new Array<Link>();
        for (let j = 1; j <= rows; j++) {
          const rowLinkText = global.Logonme.LocalizationManager.getText(`footer-column${i}-row${j}-text`, lang);
          const rowLinkUri = global.Logonme.LocalizationManager.getText(`footer-column${i}-row${j}-src`, lang);
          if (rowLinkText !== null && rowLinkText !== "") {
            const link = new Link(rowLinkUri, rowLinkText, null);
            links.push(link);
          }
        }
        this.footerColumns.push(new LinkSet(header, links));
      }
    }
  }

  private async updateFrontendVersion(): Promise<void> {
    const version = `${gitVersion.tag}-${gitVersion.branch}-${gitVersion.commit}`;
    this.frontendVersion(version);
  }

  private async updateBackendVersion(): Promise<void> {
    const uri = `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/about/version`;
    const response = await fetch(uri);
    const version = await response.text();
    this.backendVersion(version);
  }
}

export default { viewModel: PageFooter, template: template };
